let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3L5cs")).then(() => parcelRequire('7xmMz'));